import { createFileRoute } from '@tanstack/react-router'
import { SizesPage } from '@/features/sizes'

export const Route = createFileRoute('/_authenticated/sizes/')({
  component: SizesPage,
})
